<template>
    <div id="page-integrations" @click.capture="checkEmailValidationBeforeIntegration">
        <AppBreadCrumb :paths="[{ title: $t('message.integrations') }]" :select="true"></AppBreadCrumb>
        <!-- Navigation Bar -->
        <div class="integration-nav">
            <div class="big-title">{{ $t("message.allIntegrations") }}</div>
            <div class="nav-items">
                <a
                    v-for="(group, index) in integrationGroups"
                    :key="index"
                    :href="'#' + group.id"
                    class="nav-item"
                    :class="{ active: activeGroup === group.id }"
                    @click.prevent="scrollToGroup(group.id)"
                >
                    <span class="material-icons" :style="{ color: group.color }">{{ group.icon }}</span>
                    {{ group.title }}
                </a>
            </div>
        </div>

        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="pl-3 mt-3" style="flex: 0 0 100%">
                <!-- Social Media -->
                <div class="integration-group" id="social-media">
                    <h3>{{ $t("message.socialMedia") }}</h3>
                    <div class="stories">
                        <div
                            class="story whatsapp-story disabled-integration"
                            v-if="
                                multiWhatsapp &&
                                checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name) &&
                                istWhatsappV2()
                            "
                        >
                            <div class="dead-badge">Dead</div>
                            <div class="status" v-if="whatsappV2ChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="compare-button" @click="openWhatsappComparison">
                                <span class="material-icons">compare</span>
                                <span>{{ $t("message.integrationsPage.compare") }}</span>
                            </div>
                            <div class="img whatsapp">
                                <span class="material-icons star-v2"> star </span>
                                <WhatsappV2 style="width: 40px" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.whatsappV2Web") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappV2") }}
                            </div>
                        </div>
                        <div class="story whatsapp-story" @click="$router.push('integrations/whatsapp-v3')">
                            <div class="status" v-if="whatsappV3ChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="compare-button" @click="openWhatsappComparison">
                                <span class="material-icons">compare</span>
                                <span>{{ $t("message.integrationsPage.compare") }}</span>
                            </div>
                            <div class="img whatsapp">
                                <WhatsappV3Icon style="width: 40px" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.whatsappV3QR") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappV2") }}
                            </div>
                        </div>
                        <div
                            v-if="checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name)"
                            class="story whatsapp-story"
                            @click="$router.push('integrations/whatsapp-business-api')"
                        >
                            <div class="status" v-if="whatsappBusinessChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="compare-button" @click="openWhatsappComparison">
                                <span class="material-icons">compare</span>
                                <span>{{ $t("message.integrationsPage.compare") }}</span>
                            </div>
                            <div class="img whatsapp">
                                <WhatsappBusinessIcon style="width: 50px" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.whatsappBusinessAPI") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappBusiness") }}
                            </div>
                        </div>
                         <div
                            v-if="checkPermission(PERMISSION_TYPES['integrations.whatsapp.view'].tr.name)"
                            class="story"
                            @click="$router.push('integrations/waba')"
                        >
                            <div class="status" v-if="supsisWhatsappBusinessChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img whatsapp">
                                <WhatsappBusinessIcon style="width: 50px" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.whatsappBusinessAPIv2") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsWhatsappBusiness") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/instagram')">
                            <div class="status" v-if="instagramChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img instagram">
                                <InstagramIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.instagram") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsInstagram") }}
                            </div>
                        </div>

                        <div class="story instagram-v2-story" @click="$router.push('integrations/instagram-v2')">
                            <div class="status" v-if="instagramV2ChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img instagram">
                                <InstagramIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.instagramV2") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsPage.instagramV2Desc") }}
                            </div>
                        </div>

                        <div class="story" @click="$router.push('integrations/messenger')">
                            <div class="status" v-if="messengerChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img messenger">
                                <FacebookIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.messenger") }}</div>
                            <div class="description">
                                {{ $t("message.messengerIntegrationDesc") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/linkedin')">
                            <div class="status" v-if="linkedinChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img linkedin">
                                <LinkedinIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.linkedin") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsLinkedin") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/telegram-qr')">
                            <div class="status" v-if="telegramChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img telegram">
                                <TelegramIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.telegramQR") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsTelegram") }}
                            </div>
                        </div>

                        <div
                            v-if="checkPermission(PERMISSION_TYPES['integrations.telegram.view'].tr.name)"
                            class="story"
                            @click="
                                () =>
                                    telegramEnabled
                                        ? createTelegramChannel()
                                        : $feature.beforeCreateIntegrationChannel(createTelegramChannel, 'telegram')
                            "
                        >
                            <div class="status" v-if="telegramEnabled">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <a-modal
                                :title="$t('telegram.telegramTokenTitle')"
                                wrapClassName="vertical-center-modal"
                                :visible="integrateTelegramModalVisible"
                                @cancel="handleCancel()"
                                @ok="handleOk()"
                            >
                                <div class="col mb-5">
                                    <a-form-item :label="$t('telegram.typeInTelegramToken')">
                                        <a-modal
                                            v-model="visibleDeleteToken"
                                            :title="$t('telegram.telegramAlertTitle')"
                                            @ok="confirmDeleteToken"
                                            @cancel="cancelDeleteToken"
                                        >
                                            <p>{{ $t("telegram.telegramAlertText") }}</p>
                                        </a-modal>
                                        <div class="row mb-3">
                                            <a-input
                                                style="width: 90%"
                                                autofocus
                                                class="mt-2"
                                                :class="{ 'err-class': showWarning }"
                                                @change="onTelegramTokenChange"
                                                v-model="tempToken"
                                                :placeholder="$t('telegram.token')"
                                            />
                                            <a-button
                                                type="primary"
                                                icon="delete"
                                                v-if="isThereTempToken"
                                                class="ml-2 p-10 mt-2"
                                                @click="showDeleteConfirmation"
                                            ></a-button>
                                        </div>
                                    </a-form-item>

                                    <a-alert show-icon type="info">
                                        <div slot="description">
                                            {{ $t("telegram.telegramAlertForm") }}
                                            <a href="https://t.me/BotFather" target="_blank">BotFather</a>
                                        </div>
                                    </a-alert>
                                </div>
                            </a-modal>
                            <div class="img telegram">
                                <TelegramIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.telegramBotFather") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsTelegram") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/youtube-comments')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="youtubeChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img youtube">
                                <YouTubeIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.youtubeComments") }}</div>
                            <div class="description">{{ $t("message.integrationsYouTubeComments") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/google-business-reviews')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="googleBusinessChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img google-business">
                                <GoogleBusinessIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.googleBusinessReviews") }}</div>
                            <div class="description">{{ $t("message.integrationsGoogleBusinessReviews") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/google-play-reviews')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="googlePlayChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img google-play">
                                <GooglePlayIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.googlePlayReviews") }}</div>
                            <div class="description">{{ $t("message.integrationsGooglePlayReviews") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/appstore-reviews')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="appStoreChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img appstore">
                                <AppStoreIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.appStoreReviews") }}</div>
                            <div class="description">{{ $t("message.integrationsAppStoreReviews") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/google-drive')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="googleDriveChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img google-drive">
                                <GoogleDriveIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.googleDrive") }}</div>
                            <div class="description">{{ $t("message.integrationsGoogleDrive") }}</div>
                        </div>

                        <!-- Voting integrations -->
                        <!-- <div class="story voting" @click="castVote('Twitter', $event)">
                            <div class="img twitter">
                                <TwitterIcon />
                            </div>
                            <div class="title">Twitter</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Twitter" }) }}
                            </div>
                        </div>

                        <div class="story voting" @click="castVote('Slack', $event)">
                            <div class="img slack">
                                <SlackIcon />
                            </div>
                            <div class="title">Slack</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Slack" }) }}
                            </div>
                        </div>
                        <div class="story voting" @click="castVote('Skype', $event)">
                            <div class="img skype">
                                <SkypeIcon />
                            </div>
                            <div class="title">Skype</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Skype" }) }}
                            </div>
                        </div> -->
                    </div>
                </div>

                <!-- Web -->
                <div class="integration-group" id="web">
                    <h3>{{ $t("message.web") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('/integrations/webchat/bubble-settings')">
                            <div class="status">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img supsis">
                                <SupsisIcon />
                            </div>
                            <div class="title">{{ $t("message.chatWidget") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsWebchat") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webhook')">
                            <div class="img webhooks">
                                <WebhookIcon />
                            </div>
                            <div class="title">{{ $t("message.webhooks") }}</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Webhooks" }) }} .
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webtabs')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="img webtabs">
                                <span class="material-icons">tab</span>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.webTabs") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsPage.webTabsDesc") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webapps')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="img webapps">
                                <span class="material-icons">web</span>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.webApps") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsPage.webAppsDesc") }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Email -->
                <div class="integration-group" id="email">
                    <h3>{{ $t("message.email") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/mail')" v-if="isEmailFeatureEnabled()">
                            <div class="img mail">
                                <DynamicSvg name="Mail" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.mail") }}</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Mail" }) }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SMS -->
                <div class="integration-group" id="sms">
                    <h3>{{ $t("message.sms") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/sms/postacell')">
                            <div class="status" v-if="smsChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img postacell"><img src="/static/img/postacell-logo.png" /></div>
                            <div class="title">{{ $t("message.integrationsPage.smsPostacell") }}</div>
                            <div class="description">{{ $t("message.integrationsSMSPostacell") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/sms/netgsm')">
                            <div class="status" v-if="smsNetgsmChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img postacell"><img src="/static/img/netgsm-logo.svg" /></div>
                            <div class="title">{{ $t("message.integrationsPage.smsNetgsm") }}</div>
                            <div class="description">{{ $t("message.integrationsSMSNetgsm") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/sms/posta-guvercini')">
                            <div class="status" v-if="smsPostaGuverciniChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img postacell"><img src="/static/img/posta-guvercini-logo.png" /></div>
                            <div class="title">{{ $t("message.integrationsPage.smsPostaGuvercini") }}</div>
                            <div class="description">{{ $t("message.integrationsSMSPostaGuvercini") }}</div>
                        </div>
                    </div>
                </div>

                <!-- CRM -->
                <div class="integration-group" id="crm">
                    <h3>{{ $t("message.crm") }}</h3>
                    <div class="stories">
<!--                        bitrix şu an sağlıklı çalışmadığı için ui dan kaldırıldı-->
<!--                        <div class="story" @click="$router.push('integrations/bitrix24')">-->
<!--                            <div class="status" v-if="bitrixChannels.length > 0">-->
<!--                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}-->
<!--                            </div>-->
<!--                            <div class="img ideasoft">-->
<!--                                <BitrixIcon />-->
<!--                            </div>-->
<!--                            <div class="title">Bitrix24</div>-->
<!--                            <div class="description">{{ $t("message.integrationsBitrix24") }}</div>-->
<!--                        </div>-->
                        <div class="story" @click="$router.push('integrations/zoho')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="zohoChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ideasoft">
                                <ZohoIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.zohoCRM") }}</div>
                            <div class="description">{{ $t("message.integrationsZoho") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/teamgram')" style="display:none">
                            <div class="status" v-if="teamgramChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img teamgram">
                                <TeamGramIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.teamgram") }}</div>
                            <div class="description">{{ $t("message.integrationsTeamgram") }}</div>
                        </div>
                    </div>
                </div>

                <!-- E-Commerce -->
                <div class="integration-group" id="e-commerce">
                    <h3>{{ $t("message.ecommerce") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/ideasoft')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="ideasoftChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ideasoft">
                                <IdeasoftIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.ideasoft") }}</div>
                            <div class="description">{{ $t("message.integrationsIdeasoft") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/ticimax')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="ticimaxChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ticimax">
                                <div class="img postacell"><img src="/static/img/ticimax.png" /></div>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.ticimax") }}</div>
                            <div class="description">{{ $t("message.integrationsTicimax") }}</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/ticimax-v2')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="ticimaxChannelsV2.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ticimax">
                                <div class="img postacell"><img src="/static/img/ticimax.png" /></div>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.ticimaxV2") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.ticimaxV2Desc") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/trendyol')">
                            <div class="status" v-if="trendyolChannelExists.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img">
                                <TrendyolIcon />
                            </div>
                            <div class="title">{{ $t("message.trendyol") }}</div>
                            <div class="description">{{ $t("message.integrationsTrendyol") }}</div>
                        </div>
                        <div class="story" @click="$router.push('integrations/t-soft')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="tsoftChannelExists.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img">
                                <TsoftIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.tsoft") }}</div>
                            <div>
                                {{ $t("message.integrationsPage.tsoftDesc") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/ikas')">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="ikasChannelExists.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img" style="background: #deff37">
                                <IkasIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.ikas") }}</div>
                            <div>
                                {{ $t("message.integrationsPage.ikasDesc") }}
                            </div>
                        </div>

                        <!-- Voting integrations -->
                        <!-- <div class="story voting" @click="castVote('Shopify', $event)">
                            <div class="img shopify">
                                <ShopifyIcon />
                            </div>
                            <div class="title">Shopify</div>
                            <div class="description">{{ $t("message.integrateSupsiswithIntegratable", { integratable: "Shopify" }) }}</div>
                        </div> -->
                    </div>
                </div>

                <!-- Utilities -->
                <div class="integration-group" id="utilities">
                    <h3>{{ $t("message.utilities") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('/integrations/webhook')">
                            <div class="img webhooks">
                                <WebhookIcon />
                            </div>
                            <div class="title">{{ $t("message.webhooks") }}</div>
                            <div class="description">
                                {{ $t("message.integrateSupsiswithIntegratable", { integratable: "Webhooks" }) }} .
                            </div>
                        </div>
                        <div class="story" @click="$router.push('/cache-manager')">
                            <div class="img cache">
                                <span class="material-icons">storage</span>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.cacheManager") }}</div>
                            <div class="description">
                                {{ $t("message.integrationsPage.cacheManagerDesc") }}
                            </div>
                        </div>
                        <div class="story" @click="$router.push('integrations/openai')">
                            <div class="status" v-if="openaiChannels.length > 0">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img">
                                <OpenaiIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.openai") }}</div>
                            <div class="description">
                                <div>{{ $t("message.integrationsOpenAI") }}</div>
                            </div>
                        </div>
                        <div class="story" @click="showSlackIntegration">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="slackChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img slack">
                                <SlackIcon />
                            </div>
                            <div class="title">Slack</div>
                            <div class="description">
                                {{ $t("integrations.slackCardDescription") }}
                            </div>
                            <SlackIntegrationModal
                                :modalVisible="slackIntegrationModalVisible"
                                @close="slackIntegrationModalVisible = false"
                            />
                        </div>
                        <div class="story" @click="showPushoverIntegration">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="status" v-if="pushoverChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img pushover">
                                <PushoverIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.pushover") }}</div>
                            <div class="description">
                                {{ $t("integrations.pushoverCardDescription") }}
                            </div>
                            <PushoverIntegrationModal
                                :modalVisible="pushoverIntegrationModalVisible"
                                @close="pushoverIntegrationModalVisible = false"
                            />
                        </div>
                        <div class="story story--chrome-ext" @click="chromeExtModalVisible = true">
                            <div class="badge-free">{{ $t("message.integrationsPage.free") }}</div>
                            <div class="badge-new">NEW</div>
                            <div class="img chrome-ext">
                                <svg width="44" height="44" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                                </svg>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.chromeExtTitle") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.chromeExtDesc") }}</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/copilot-prompts')">
                            <div class="img copilot-prompts">
                                <CopilotPromptsIcon style="width: 40px; height: 40px;" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.copilotPrompts") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.copilotPromptsDesc") }}</div>
                        </div>
                    </div>
                </div>

                <!-- Advertising -->
                <div class="integration-group" id="advertising">
                    <h3>{{ $t("message.advertising") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('integrations/meta-leads')">
                            <div class="status" v-if="metaLeadsChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img meta">
                                <MetaIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.metaLeads") }}</div>
                            <div class="description">{{ $t("message.integrationsMetaLeads") }}</div>
                        </div>

                        <div class="story" @click="$router.push('integrations/meta-insights')">
                            <div class="status" v-if="metaInsightsChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img meta">
                                <MetaIcon />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.metaInsights") }}</div>
                            <div class="description">{{ $t("message.integrationsMetaInsights") }}</div>
                        </div>

                    </div>
                </div>

                <!-- Ses -->
                <div class="integration-group" id="ses">
                    <h3>{{ $t("message.integrationsPage.voice") }}</h3>
                    <div class="stories">
                        <div class="story" @click="$router.push('/integrations/webphone/redsantral')">
                            <div class="status" v-if="webphoneChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img webphone">
                                <span class="material-icons" style="color: #d32f2f">phone</span>
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.webphoneRedsantral") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.webphoneRedsantralDesc") }}</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webphone/telnyx')">
                            <div class="status" v-if="telnyxChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img telnyx">
                                <img src="/static/img/telnyx.png" alt="Telnyx" style="width: 40px; height: 40px;" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.webphoneTelnyx") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.webphoneTelnyxDesc") }}</div>
                        </div>
                        <div class="story" @click="$router.push('/integrations/webphone/netgsm')">
                            <div class="status" v-if="netgsmChannelExists">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img netgsm">
                                <img src="/static/img/netgsm.png" alt="NetGSM" style="width: 40px; height: 40px;" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.webphoneNetgsm") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.webphoneNetgsmDesc") }}</div>
                        </div>
                        <PermissionController :permissions="['voice-agent.get']">
                            <div class="story" @click="$router.push('integrations/voice-agent')">
                                <div class="status" v-if="retellChannelExists">
                                    <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                                </div>
                                <div class="img retell">
                                    <span class="material-icons">record_voice_over</span>
                                </div>
                                <div class="title">{{ $t("message.integrationsPage.aiVoiceAgent") }}</div>
                                <div class="description">
                                    {{ $t("message.integrationsPage.aiVoiceAgentDesc") }}
                                </div>
                            </div>
                        </PermissionController>
                    </div>
                </div>

                <!-- Chrome Extension Detail Modal -->
                <a-modal
                    :visible="chromeExtModalVisible"
                    :footer="null"
                    :width="720"
                    :body-style="{ padding: 0 }"
                    wrap-class-name="chrome-ext-modal"
                    @cancel="chromeExtModalVisible = false"
                >
                    <div class="chrome-ext-modal__inner">
                        <a-carousel arrows dots-class="chrome-ext-modal__dots">
                            <template #prevArrow>
                                <div class="carousel-arrow carousel-arrow--prev">
                                    <span class="material-icons">chevron_left</span>
                                </div>
                            </template>
                            <template #nextArrow>
                                <div class="carousel-arrow carousel-arrow--next">
                                    <span class="material-icons">chevron_right</span>
                                </div>
                            </template>
                            <div v-for="(img, i) in chromeExtImages" :key="i" class="chrome-ext-modal__slide">
                                <img :src="img" :alt="'Supsis WhatsApp Extension ' + (i + 1)" />
                            </div>
                        </a-carousel>

                        <div class="chrome-ext-modal__body">
                            <div class="chrome-ext-modal__header">
                                <div class="chrome-ext-modal__icon">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                                    </svg>
                                </div>
                                <div>
                                    <div class="chrome-ext-modal__title">{{ $t("message.integrationsPage.chromeExtTitle") }}</div>
                                    <div class="chrome-ext-modal__subtitle">{{ $t("message.integrationsPage.chromeExtSubtitle") }}</div>
                                </div>
                            </div>

                            <p class="chrome-ext-modal__lead">{{ $t("message.integrationsPage.chromeExtLead") }}</p>

                            <ul class="chrome-ext-modal__features">
                                <li v-for="(feat, i) in chromeExtFeatures" :key="i">
                                    <span class="material-icons">{{ feat.icon }}</span>
                                    <div>
                                        <strong>{{ feat.title }}</strong>
                                        <span>{{ feat.desc }}</span>
                                    </div>
                                </li>
                            </ul>

                            <div class="chrome-ext-modal__setup">
                                <div class="chrome-ext-modal__setup-title">{{ $t("message.integrationsPage.chromeExtSetupTitle") }}</div>
                                <ol>
                                    <li>{{ $t("message.integrationsPage.chromeExtStep1") }}</li>
                                    <li>{{ $t("message.integrationsPage.chromeExtStep2") }}</li>
                                    <li>{{ $t("message.integrationsPage.chromeExtStep3") }}</li>
                                </ol>
                            </div>

                            <a
                                href="https://chromewebstore.google.com/detail/supsis-whatsapp-panel/chibdpbliekjfakffkfihdbinclcgkih"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="chrome-ext-modal__cta"
                                @click.stop
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>
                                {{ $t("message.integrationsPage.chromeExtCta") }}
                            </a>
                        </div>
                    </div>
                </a-modal>

                <!-- AI / LLM -->
                <div class="integration-group" id="ai">
                    <h3>{{ $t("message.artificialIntelligence") || $t("message.integrationsPage.artificialIntelligenceFallback") }}</h3>
                    <div class="stories">
                        <!-- OpenRouter (Wildcard) -->
                        <div class="story" @click="$router.push('integrations/openrouter/openrouter')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('openrouter')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/openrouter.svg" alt="OpenRouter" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.openRouter") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.openRouterDesc") }}</div>
                        </div>

                        <!-- OpenAI -->
                        <div class="story" @click="$router.push('integrations/openrouter/openai')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('openai')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/openai.svg" alt="OpenAI" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.openai") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.openAIDesc") }}</div>
                        </div>

                        <!-- Google AI Studio -->
                        <div class="story" @click="$router.push('integrations/openrouter/google')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('google')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/google.svg" alt="Google AI" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.googleAIStudio") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.googleAIStudioDesc") }}</div>
                        </div>

                        <!-- Anthropic -->
                        <div class="story" @click="$router.push('integrations/openrouter/anthropic')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('anthropic')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/anthropic.svg" alt="Anthropic" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.anthropic") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.anthropicDesc") }}</div>
                        </div>

                        <!-- Mistral -->
                        <div class="story" @click="$router.push('integrations/openrouter/mistral')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('mistral')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/mistral.webp" alt="Mistral" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.mistral") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.mistralDesc") }}</div>
                        </div>

                        <!-- Microsoft Azure -->
                        <div class="story" @click="$router.push('integrations/openrouter/azure')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('azure')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/microsoft.svg" alt="Microsoft Azure" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.microsoftAzure") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.microsoftAzureDesc") }}</div>
                        </div>

                        <!-- Amazon Bedrock -->
                        <div class="story" @click="$router.push('integrations/openrouter/bedrock')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('bedrock')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/aws.svg" alt="Amazon Bedrock" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.amazonBedrock") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.amazonBedrockDesc") }}</div>
                        </div>

                        <!-- Cohere -->
                        <div class="story" @click="$router.push('integrations/openrouter/cohere')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('cohere')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/cohere.svg" alt="Cohere" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.cohere") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.cohereDesc") }}</div>
                        </div>

                        <!-- xAI -->
                        <div class="story" @click="$router.push('integrations/openrouter/xai')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('xai')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/xai.svg" alt="xAI" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.xai") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.xaiDesc") }}</div>
                        </div>

                        <!-- DeepInfra -->
                        <div class="story" @click="$router.push('integrations/openrouter/deepinfra')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('deepinfra')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/deepinfra.webp" alt="DeepInfra" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.deepInfra") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.deepInfraDesc") }}</div>
                        </div>

                        <!-- Together -->
                        <div class="story" @click="$router.push('integrations/openrouter/together')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('together')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/togetherai.svg" alt="Together" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.together") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.togetherDesc") }}</div>
                        </div>

                        <!-- Fireworks -->
                        <div class="story" @click="$router.push('integrations/openrouter/fireworks')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('fireworks')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/fireworks.svg" alt="Fireworks" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.fireworks") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.fireworksDesc") }}</div>
                        </div>

                        <!-- SiliconFlow -->
                        <div class="story" @click="$router.push('integrations/openrouter/siliconflow')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('siliconflow')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/siliconflow.png" alt="SiliconFlow" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.siliconFlow") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.siliconFlowDesc") }}</div>
                        </div>

                        <!-- Parasail -->
                        <div class="story" @click="$router.push('integrations/openrouter/parasail')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('parasail')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/parasail.svg" alt="Parasail" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.parasail") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.parasailDesc") }}</div>
                        </div>

                        <!-- Nebius -->
                        <div class="story" @click="$router.push('integrations/openrouter/nebius')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('nebius')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/nebius.svg" alt="Nebius" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.nebius") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.nebiusDesc") }}</div>
                        </div>

                        <!-- Alibaba Cloud -->
                        <div class="story" @click="$router.push('integrations/openrouter/alibaba')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('alibaba')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/alibaba.svg" alt="Alibaba Cloud" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.alibabaCloud") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.alibabaCloudDesc") }}</div>
                        </div>

                        <!-- Xiaomi -->
                        <div class="story" @click="$router.push('integrations/openrouter/xiaomi')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('xiaomi')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/xiaomi.svg" alt="Xiaomi" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.xiaomi") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.xiaomiDesc") }}</div>
                        </div>

                        <!-- SambaNova -->
                        <div class="story" @click="$router.push('integrations/openrouter/sambanova')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('sambanova')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/sambanova.webp" alt="SambaNova" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.sambaNova") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.sambaNovaDesc") }}</div>
                        </div>

                        <!-- Moonshot AI -->
                        <div class="story" @click="$router.push('integrations/openrouter/moonshot')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('moonshot')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/moonshot.svg" alt="Moonshot AI" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.moonshotAI") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.moonshotAIDesc") }}</div>
                        </div>

                        <!-- Minimax -->
                        <div class="story" @click="$router.push('integrations/openrouter/minimax')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('minimax')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/minimax.svg" alt="Minimax" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.minimax") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.minimaxDesc") }}</div>
                        </div>

                        <!-- NVIDIA -->
                        <div class="story" @click="$router.push('integrations/openrouter/nvidia')">
                            <div class="status" v-if="getOpenRouterChannelByProvider('nvidia')">
                                <span class="material-icons"> done </span> {{ $t("message.installationOK") }}
                            </div>
                            <div class="img ai-provider">
                                <img src="https://static.supsis.live/common/ai/nvidia.svg" alt="NVIDIA" />
                            </div>
                            <div class="title">{{ $t("message.integrationsPage.nvidia") }}</div>
                            <div class="description">{{ $t("message.integrationsPage.nvidiaDesc") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- WhatsApp Comparison Modal -->
        <a-modal
            :visible.sync="whatsappComparisonModalVisible"
            :cancel-text="null"
            @ok="() => (whatsappComparisonModalVisible = false)"
            :width="1400"
            :footer="false"
            :footer-hide="true"
            class="custom-modal whatsapp-comparison-modal"
            v-on:cancel="whatsappComparisonModalVisible = false"
            :title="$t('message.integrationsPage.whatsappComparisonTitle')"
        >
            <WhatsappComparison />
        </a-modal>
    </div>
</template>

<script>
import SideMenuBar from "./Chatbot/SideMenuBar";
import { mapActions, mapGetters, mapState } from "vuex";
import WebhookIcon from "./Chatbot/pages/integrations/svg/WebhookIcon";
import OpenaiIcon from "./Chatbot/pages/integrations/svg/OpenaiIcon";
import SupsisIcon from "./Chatbot/pages/integrations/svg/SupsisIcon";
import WhatsappIcon from "./Chatbot/pages/integrations/svg/WhatsappIcon";
import InstagramIcon from "./Chatbot/pages/integrations/svg/InstagramIcon";
import TelegramIcon from "./Chatbot/pages/integrations/svg/TelegramIcon";
import TwitterIcon from "./Chatbot/pages/integrations/svg/TwitterIcon";
import FacebookIcon from "./Chatbot/pages/integrations/svg/FacebookIcon.vue";
import SkypeIcon from "./Chatbot/pages/integrations/svg/SkypeIcon.vue";
import ShopifyIcon from "../../components/fast-initialize/svg/ShopifyIcon";
import SlackIcon from "./Chatbot/pages/integrations/svg/SlackIcon.vue";
import MaliIcon from "./Chatbot/pages/integrations/svg/MailIcon";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";
import log2 from "../../utils/log2";
import WhatsappBusinessIcon from "./Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import LinkedinIcon from "./Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import CONFIG from "../../config/config";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import AppBreadCrumb from "../../components/common/AppBreadCrumb.vue";
import WhatsappV1 from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV1.vue";
import WhatsappV2 from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import IdeasoftIcon from "./Chatbot/pages/integrations/svg/IdeasoftIcon.vue";
import MessengerIcon from "./Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TeamGramIcon from "./Chatbot/pages/integrations/svg/TeamGramIcon.vue";
import MetaIcon from "./Chatbot/pages/integrations/svg/MetaIcon.vue";
import YouTubeIcon from "./Chatbot/pages/integrations/svg/YouTubeIcon.vue";
import GoogleBusinessIcon from "./Chatbot/pages/integrations/svg/GoogleBusinessIcon.vue";
import GooglePlayIcon from "./Chatbot/pages/integrations/svg/GooglePlayIcon.vue";
import AppStoreIcon from "./Chatbot/pages/integrations/svg/AppStoreIcon.vue";
import GoogleDriveIcon from "./Integrations/google-drive/GoogleDriveIcon.vue";
import BitrixIcon from "./Chatbot/pages/integrations/svg/BitrixIcon.vue";
import TrendyolIcon from "./Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import TsoftIcon from "./Chatbot/pages/integrations/svg/TsoftIcon.vue";
import IkasIcon from "./Chatbot/pages/integrations/svg/IkasIcon.vue";
import ZohoIcon from "./Chatbot/pages/integrations/svg/ZohoIcon.vue";
import WhatsappV3Icon from "./Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";
import confetti from "canvas-confetti";
import DynamicSvg from "../../components/DynamicSvg.vue";
import PermissionController from "../../components/permission-controller/PermissionController";
import WhatsappComparison from "../../components/WhatsappComparison.vue";
import PushoverIcon from "./Chatbot/pages/integrations/svg/PushoverIcon.vue";
import PushoverIntegrationModal from "./Chatbot/pages/integrations/components/PushoverIntegrationModal.vue";
import SlackIntegrationModal from "./Chatbot/pages/integrations/components/SlackIntegrationModal.vue";
import CopilotPromptsIcon from "../../components/svg/CopilotPromptsIcon.vue";

const log = log2("Integrations");
export default {
    name: "Integrations",
    components: {
        DynamicSvg,
        WhatsappV3Icon,
        ZohoIcon,
        TrendyolIcon,
        TsoftIcon,
        IkasIcon,
        BitrixIcon,
        TeamGramIcon,
        MetaIcon,
        YouTubeIcon,
        GoogleBusinessIcon,
        GooglePlayIcon,
        AppStoreIcon,
        GoogleDriveIcon,
        MessengerIcon,
        IdeasoftIcon,
        AppBreadCrumb,
        SlackIcon,
        ShopifyIcon,
        SkypeIcon,
        FacebookIcon,
        TwitterIcon,
        WhatsappIcon,
        InstagramIcon,
        TelegramIcon,
        SupsisIcon,
        SideMenuBar,
        WebhookIcon,
        OpenaiIcon,
        WhatsappBusinessIcon,
        MaliIcon,
        WhatsappV1,
        WhatsappV2,
        LinkedinIcon,
        WhatsappComparison,
        PushoverIcon,
        PushoverIntegrationModal,
        SlackIntegrationModal,
        CopilotPromptsIcon,
    },
    data() {
        return {
            integrateTelegramModalVisible: false,
            showWarning: false,
            tempToken: "",
            visibleDeleteToken: false,
            handleSaveSetting: _.debounce((newSettings) => {
                this.updateSettings(newSettings);
            }, 100).bind(this),
            multiWhatsapp: CONFIG.MULTI_WHATSAPP.enabled,
            isThereTempToken: false,
            PERMISSION_TYPES,
            activeGroup: "social-media",
            whatsappComparisonModalVisible: false,
            slackIntegrationModalVisible: false,
            pushoverIntegrationModalVisible: false,
            chromeExtModalVisible: false,
            chromeExtImages: [
                'https://static.supsis.live/5d14ee322d95ad001ebdf213/whatsapp/chat/image/169d26c4-fcee-4334-9dde-3a9d1d53f063.jpg',
                'https://static.supsis.live/5d14ee322d95ad001ebdf213/whatsapp/chat/image/420edf68-ce7b-4d84-925b-ce6ad6ec67d9.jpg',
                'https://static.supsis.live/5d14ee322d95ad001ebdf213/whatsapp/chat/image/a4ad43e4-f120-4f07-81d7-c3d38429e864.jpg',
                'https://static.supsis.live/5d14ee322d95ad001ebdf213/whatsapp/chat/image/776a3bcf-8e0e-48c8-abbd-05f81ce0472c.jpg',
            ],
            integrationGroups: [
                { id: "social-media", title: this.$t("message.socialMedia"), icon: "share", color: "#ea4335" },
                { id: "web", title: this.$t("message.web"), icon: "language", color: "#4285f4" },
                { id: "email", title: this.$t("message.email"), icon: "email", color: "#fbbc05" },
                { id: "sms", title: this.$t("message.sms"), icon: "sms", color: "#34a853" },
                { id: "crm", title: this.$t("message.crm"), icon: "people", color: "#ff7043" },
                { id: "e-commerce", title: this.$t("message.ecommerce"), icon: "shopping_cart", color: "#9c27b0" },
                { id: "utilities", title: this.$t("message.utilities"), icon: "build", color: "#795548" },
                        { id: "advertising", title: this.$t("message.advertising"), icon: "campaign", color: "#607d8b" },
                PermissionController.check(["voice-agent.get"]) && {
                    id: "ses",
                    title: this.$t("message.integrationsPage.voice"),
                    icon: "mic",
                    color: "#3f51b5",
                },
                { id: "ai", title: this.$t("message.artificialIntelligence"), icon: "psychology", color: "#00bcd4" },
            ].filter(Boolean),
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            emailDomain: (state) =>
                state.site.site.alias === "supsis"
                    ? CONFIG.EMAIL_DOMAIN
                    : `${state.site.site.alias}.${CONFIG.EMAIL_DOMAIN}`,
            whatsappV1ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-qr"),
            whatsappV2ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-v2"),
            whatsappBusinessChannelExists: (state) =>
                state.channel.channels.some((x) => x.type === "whatsapp-business-api"),
            supsisWhatsappBusinessChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-business-api-supsis"),
            linkedinChannelExists: (state) => state.channel.channels.some((x) => x.type === "linkedin-unipile"),
            telegramChannelExists: (state) => state.channel.channels.some((x) => x.type === "telegram-unipile"),
            whatsappV3ChannelExists: (state) => state.channel.channels.some((x) => x.type === "whatsapp-unipile"),
            messengerChannelExists: (state) => state.channel.channels.some((x) => x.type === "messenger"),
            instagramChannelExists: (state) => state.channel.channels.some((x) => x.type === "instagram"),
            instagramV2ChannelExists: (state) => state.channel.channels.some((x) => x.type === "instagram-v2"),
            metaLeadsChannelExists: (state) => state.channel.channels.some((x) => x.type === "meta-leads"),
            metaInsightsChannelExists: (state) => state.channel.channels.some((x) => x.type === "meta-insights"),
            youtubeChannelExists: (state) => state.channel.channels.some((x) => x.type === "youtube-comments"),
            googleBusinessChannelExists: (state) => state.channel.channels.some((x) => x.type === "google-business-reviews"),
            googlePlayChannelExists: (state) => state.channel.channels.some((x) => x.type === "google-play-reviews"),
            appStoreChannelExists: (state) => state.channel.channels.some((x) => x.type === "appstore-reviews"),
            googleDriveChannelExists: (state) => state.channel.channels.some((x) => x.type === "google-drive"),
            smsChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
            smsNetgsmChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-netgsm"),
            smsPostaGuverciniChannels: (state) =>
                state.channel.channels.filter((x) => x.type === "sms-posta-guvercini"),
            openaiChannels: (state) => state.channel.channels.filter((x) => x.type === "openai"),
            ideasoftChannels: (state) => state.channel.channels.filter((x) => x.type === "ideasoft"),
            bitrixChannels: (state) => state.channel.channels.filter((x) => x.type === "bitrix"),
            zohoChannels: (state) => state.channel.channels.filter((x) => x.type === "zoho"),
            ticimaxChannels: (state) => state.channel.channels.filter((x) => x.type === "ticimax"),
            ticimaxChannelsV2: (state) => state.channel.channels.filter((x) =>x.type === "ticimax-v2"),
            teamgramChannels: (state) => state.channel.channels.filter((x) => x.type === "teamgram"),
            holidayPlusChannels: (state) => state.channel.channels.filter((x) => x.type === "holiday-plus"),
            trendyolChannelExists: (state) => state.channel.channels.filter((x) => x.type === "trendyol"),
            tsoftChannelExists: (state) => state.channel.channels.filter((x) => x.type === "t-soft"),
            ikasChannelExists: (state) => state.channel.channels.filter((x) => x.type === "ikas"),
            retellChannelExists: (state) => state.channel.channels.some((x) => x.type === "retell"),
            webphoneChannelExists: (state) => state.channel.channels.some((x) => x.type === "webphone-kirmizisantral"),
            telnyxChannelExists: (state) => state.channel.channels.some((x) => x.type === "webphone-telnyx"),
            netgsmChannelExists: (state) => state.channel.channels.some((x) => x.type === "webphone-netgsm"),
            slackChannelExists: (state) => state.channel.channels.some((x) => x.type === "slack" && x.enabled && !x.isDeleted),
            pushoverChannelExists: (state) => state.channel.channels.some((x) => x.type === "pushover" && x.enabled && !x.isDeleted),
            openrouterChannels: (state) => state.channel.channels.filter((x) => x.type === "openrouter" && !x.isDeleted),
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            telegramEnabled: "setting/telegramEnabled",
            checkPermission: "auth/checkPermission",
        }),
        chromeExtFeatures() {
            return [
                {
                    icon: 'phone_in_talk',
                    title: this.$t('message.integrationsPage.chromeExtFeat1Title'),
                    desc: this.$t('message.integrationsPage.chromeExtFeat1Desc'),
                },
                {
                    icon: 'integration_instructions',
                    title: this.$t('message.integrationsPage.chromeExtFeat2Title'),
                    desc: this.$t('message.integrationsPage.chromeExtFeat2Desc'),
                },
                {
                    icon: 'center_focus_strong',
                    title: this.$t('message.integrationsPage.chromeExtFeat3Title'),
                    desc: this.$t('message.integrationsPage.chromeExtFeat3Desc'),
                },
                {
                    icon: 'bolt',
                    title: this.$t('message.integrationsPage.chromeExtFeat4Title'),
                    desc: this.$t('message.integrationsPage.chromeExtFeat4Desc'),
                },
            ];
        },
        token: {
            get() {
                return _.get(this.settings, "telegrambot.token", null);
            },
            async set(value) {
                await this.setValue("telegrambot.token", value);
                this.updateTelegramToken(value);
            },
        },
    },
    methods: {
        checkEmailValidationBeforeIntegration(event) {
            const story = event.target && event.target.closest ? event.target.closest(".story") : null;
            if (!story || !this.user || this.user.emailValidated === true) return;
            event.preventDefault();
            event.stopPropagation();
            this.$root.$emit("show-email-validation-modal");
            this.$message.warning("Entegrasyon kanalı oluşturmak için önce e-posta adresinizi doğrulamalısınız.");
        },
        castVote(name, event) {
            const buttonRect = event.target.getBoundingClientRect();
            const centerX = (buttonRect.left + buttonRect.width / 2) / window.innerWidth;
            const centerY = (buttonRect.top + buttonRect.height / 2 + 50) / window.innerHeight;

            this.showConfetti(centerX, centerY);
            this.showSuccessNotification(name);
        },
        showConfetti(x, y) {
            confetti({
                particleCount: 90,
                spread: 50,
                scalar: 0.8,
                origin: { x, y },
            });
        },
        showSuccessNotification(name) {
            this.$notification.success({
                message: this.$t("message.voteSuccess"),
                description: this.$t(`message.voteSuccessDescription`, { integrationName: name }),
            });
        },
        showDeleteConfirmation() {
            this.visibleDeleteToken = true;
            this.visibleDeleteToken = false;
            this.tempToken = "";
        },
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        createTelegramChannel() {
            this.integrateTelegramModalVisible = true;
        },
        isEmailFeatureEnabled() {
            return CONFIG.EMAIL_SERVICE_ENABLED;
        },
        isHolidayPlusEnabled() {
            return CONFIG.HOLIDAY_PLUS.enabled;
        },
        updateTelegramToken(token) {
            log("updateTelegramToken", token);
            // this.setValue("telegrambot.token", token);
            sendSocketMessage("admin settings-updated", {
                siteId: this.site._id,
            });
            setTimeout(() => {
                sendSocketMessage("telegram subscribe", {
                    siteId: this.site._id,
                });
            }, 500);
        },
        deleteTelegramToken() {
            this.setValue("telegrambot.token", null);
        },
        handleOk() {
            if (!!this.tempToken && !!this.tempToken.length) {
                this.showWarning = false;
                this.setValue("telegrambot.token", this.tempToken);
            } else {
                this.showWarning = true;
            }
            this.integrateTelegramModalVisible = false;
            sendSocketMessage("user settings-updated", {
                siteId: this.site._id,
            });
        },
        handleCancel() {
            this.integrateTelegramModalVisible = false;
            this.tempToken = this.token;
        },
        onTelegramTokenChange(e) {
            console.log("onTelegramTokenChange", e.target.value);
            this.tempToken = e.target.value;
            this.showWarning = false;
        },
        confirmDeleteToken() {
            this.deleteTelegramToken();
            this.visibleDeleteToken = false;
            this.integrateTelegramModalVisible = false;
        },
        cancelDeleteToken() {
            this.tempToken = this.token;
            this.visibleDeleteToken = false;
        },
        async setValue(key, value) {
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });

            if (newSettings.then) {
                return newSettings.then((x) => this.handleSaveSetting(x));
            } else {
                return this.handleSaveSetting(newSettings);
            }
        },
        istWhatsappV2() {
            return CONFIG.WHATSAPP_V2;
        },
        scrollToGroup(groupId) {
            const element = document.getElementById(groupId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
                this.activeGroup = groupId;
            }
        },
        getOpenRouterChannelByProvider(provider) {
            return this.openrouterChannels.find(
                (ch) => ch.payload && ch.payload.provider === provider && ch.enabled
            );
        },
        handleScroll() {
            const groups = this.integrationGroups.map((g) => document.getElementById(g.id));
            const scrollPosition = window.scrollY + 100;

            for (let i = groups.length - 1; i >= 0; i--) {
                if (groups[i] && groups[i].offsetTop <= scrollPosition) {
                    this.activeGroup = this.integrationGroups[i].id;
                    break;
                }
            }
        },
        openWhatsappComparison(event) {
            event.stopPropagation();
            this.whatsappComparisonModalVisible = true;
        },
        showSlackIntegration() {
            this.slackIntegrationModalVisible = true;
        },
        showPushoverIntegration() {
            this.pushoverIntegrationModalVisible = true;
        },
    },
    mounted() {
        if (!!this.token) this.tempToken = this.token;
        const query = this.$route.query;
        if (query.showModal && query.showModal === "true") {
            this.integrateTelegramModalVisible = true;
        }
        window.addEventListener("scroll", _.throttle(this.handleScroll, 100));
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["integrations.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        token(newVal, oldVal) {
            if (!!newVal && !!newVal.length > 0) {
                if (!oldVal) {
                    this.tempToken = newVal;
                }
            }
        },
        tempToken(newVal) {
            if (newVal === "") {
                this.visibleDeleteToken = true;
            }
            if (newVal) {
                if (newVal.length > 0) {
                    this.isThereTempToken = true;
                } else {
                    this.isThereTempToken = false;
                }
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

<style lang="scss" scoped>
#page-integrations {
    overflow: scroll;

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .stories {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1.5rem;

        .story {
            position: relative;
            background: #fff;
            border-radius: 12px;
            padding: 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 320px;
            min-width: 300px;
            max-width: 300px;
            height: 260px;
            box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
            border: 1px solid #e8eef3;
            display: flex;
            flex-direction: column;

            .status {
                background-color: #f5f8fb;
                border: 1px solid #dbe1e8;
                border-radius: 8px;
                color: #919ead;
                font-size: 12px;
                font-weight: 600;
                padding: 6px 10px;
                position: absolute;
                right: 16px;
                top: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 4px;

                .material-icons {
                    font-size: 16px;
                }
            }

            .badge-free {
                position: absolute;
                top: 14px;
                left: 14px;
                z-index: 2;
                display: inline-flex;
                align-items: center;
                gap: 6px;
                padding: 5px 11px 5px 9px;
                background: linear-gradient(135deg, #10b981 0%, #22c55e 55%, #4ade80 100%);
                color: #fff;
                font-size: 10.5px;
                font-weight: 700;
                letter-spacing: 0.6px;
                text-transform: uppercase;
                border-radius: 999px;
                box-shadow:
                    0 4px 10px rgba(16, 185, 129, 0.32),
                    inset 0 0 0 1px rgba(255, 255, 255, 0.18);

                &::before {
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35);
                    animation: badge-free-pulse 1.8s ease-in-out infinite;
                }
            }

            @keyframes badge-free-pulse {
                0%, 100% {
                    opacity: 1;
                    transform: scale(1);
                }
                50% {
                    opacity: 0.55;
                    transform: scale(0.8);
                }
            }

            &.voting {
                background: #f8f9fa;

                &:after {
                    background: #008aff;
                    border-radius: 8px;
                    color: #fff;
                    content: "VOTING";
                    font-size: 13px;
                    font-weight: 600;
                    padding: 6px 12px;
                    position: absolute;
                    right: 16px;
                    top: 16px;
                }
            }

            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1);
                border-color: #008aff;

                .img:after {
                    transform: rotate(45deg) translate(-20%, -150%);
                    transition: all 0.4s;
                }
            }

                &.disabled-integration {
                pointer-events: none;
                user-select: none;
                position: relative;

                // İçerik elemanlarını gri yap
                > *:not(.dead-badge) {
                    opacity: 0.7;
                    filter: grayscale(100%);
                }

                .dead-badge {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%) rotate(-15deg);
                    background-color: #f44336;
                    color: white;
                    padding: 0.5rem 1rem;
                    font-weight: bold;
                    font-size: 1.5rem;
                    border-radius: 8px;
                    z-index: 80;
                    border: 2px solid white;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
                    text-transform: uppercase;
                    letter-spacing: 2px;
                }
            }

            &.whatsapp-story {
                    &:hover {
                        .compare-button {
                            opacity: 1;
                            visibility: visible;
                        }
                    }
                }

                &.instagram-v2-story {
                    @keyframes pulse {
                        0%, 100% {
                            transform: scale(1);
                        }
                        50% {
                            transform: scale(1.05);
                        }
                    }
                }

            .compare-button {
                position: absolute;
                top: 16px;
                right: 16px;
                background: #25d366;
                color: white;
                border: none;
                border-radius: 20px;
                padding: 8px 12px;
                font-size: 12px;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;
                opacity: 0;
                visibility: hidden;
                transition: all 0.3s ease;
                z-index: 10;

                &:hover {
                    background: #128c7e;
                    transform: scale(1.05);
                }

                .material-icons {
                    font-size: 16px;
                }
            }

            .title {
                margin: 16px 0 12px;
                font-weight: 600;
                font-size: 18px;
                color: #2c3e50;
            }

            .description {
                font-size: 14px;
                color: lightslategrey;
                line-height: 1.4;
                margin-bottom: 12px;
                display: block;
                max-height: 4.5em;
                position: relative;
            }

            .img {
                width: 80px;
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 12px;
                overflow: hidden;
                position: relative;

                &.webhooks {
                    background: #7159c2;
                }

                &.postacell,
                &.ticimax,
                &.holidayplus {
                    width: 200px;
                }

                &.ideasoft {
                    width: 200px;
                }

                &.supsis {
                    background: #e8eef3;
                }

                &.openai {
                    background: #a2cbed;
                }

                &.whatsapp {
                    background: #58ca64;
                }

                &.linkedin {
                    background: #e2e5ff;
                }

                &.retell {
                    background: #673ab7;

                    .material-icons {
                        color: #fff;
                    }
                }

                &.webphone {
                    background: #f5f5f5;

                    .material-icons {
                        font-size: 40px;
                    }
                }

                &.telnyx {
                    background: #f0f8ff;

                    img {
                        object-fit: contain;
                    }
                }

                &.netgsm {
                    background: #f5f5f5;

                    img {
                        object-fit: contain;
                    }
                }

                &.instagram {
                    background: radial-gradient(
                        circle at 30% 107%,
                        #fdf497 0%,
                        #fdf497 5%,
                        #fd5949 45%,
                        #d6249f 60%,
                        #285aeb 90%
                    );
                }

                &.youtube {
                    background: #fff;
                    svg {
                        width: 60px;
                        height: 60px;
                    }
                }

                &.google-business {
                    background: #fff;
                    svg {
                        width: 60px;
                        height: 60px;
                    }
                }

                &.telegram {
                    background: #29b6f6;
                }

                &.twitter {
                    background: #3ecdfb;
                }

                &.slack {
                    background: #4A154B;
                }

                &.pushover {
                    background: #4A90D9;
                }

                &.mail {
                    justify-content: unset !important;

                    svg {
                        width: 100%;
                        height: 100%;
                    }
                }

                &.facebook,
                &.skype,
                &.shopify {
                    background: #ffffff;
                }

                &.teamgram svg {
                    width: 100%;
                }

                &.webtabs {
                    background: #e3f2fd;

                    .material-icons {
                        color: #1976d2;
                        font-size: 32px;
                    }
                }

                &.webapps {
                    background: #e8f5e9;

                    .material-icons {
                        color: #4caf50;
                        font-size: 32px;
                    }
                }

                &.cache {
                    background: #e3f2fd;

                    .material-icons {
                        color: #1976d2;
                        font-size: 32px;
                    }
                }

                &.retell {
                    background: #673ab7;
                }

                &.ai-provider {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;

                    img {
                        width: 50px;
                        height: 50px;
                        object-fit: contain;
                    }
                }

                svg {
                    width: 65%;
                }

                &:after {
                    background: #fff;
                    bottom: 0;
                    content: "";
                    height: 100%;
                    left: -10%;
                    opacity: 0.3;
                    position: absolute;
                    top: 0;
                    transform: rotate(45deg) translate(-20%, 150%);
                    width: 160%;
                }
            }

            > div:last-child {
                color: #64748b;
                font-size: 14px;
                line-height: 1.5;
                margin-top: auto;
            }
        }
    }
}

.star-v2 {
    position: absolute !important;
    top: 0px !important;
    right: 0px !important;
    color: yellow !important;
}

.integration-group {
    margin-bottom: 2rem;
    padding: 1rem;

    h3 {
        font-size: 1.2rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }
}

.integration-nav {
    position: sticky;
    top: 45px;
    z-index: 100;
    background: white;
    //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0.5rem 1rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;

    .nav-items {
        display: flex;
        gap: 1rem;
        overflow-x: auto;
        padding: 0.5rem;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .nav-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border-radius: 20px;
        white-space: nowrap;
        transition: all 0.3s ease;
        color: #666;
        text-decoration: none;

        .material-icons {
            font-size: 20px;
        }

        &:hover {
            background: #f5f5f5;
        }

        &.active {
            background: #f0f0f0;
            font-weight: 600;
            color: #333;
        }
    }
}

.integration-group {
    scroll-margin-top: 100px;
}

.whatsapp-comparison-modal {
    .ant-modal-body {
        padding: 0px !important;
        max-height: 85vh;
        overflow: hidden;
    }
    .ant-modal-content {
        height: 90vh !important;
    }
}

// Chrome Extension Card
.story--chrome-ext {
    border: 2px solid #e8faf0 !important;
    background: linear-gradient(135deg, #f0fff4 0%, #fff 60%) !important;

    .badge-new {
        position: absolute;
        top: 16px;
        right: 16px;
        background: #25D366;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 1px;
        padding: 4px 10px;
        border-radius: 20px;
    }

    .img.chrome-ext {
        background: #e8faf0;
        width: 80px;
        height: 80px;
    }

    &:hover {
        border-color: #25D366 !important;
    }
}

// Chrome Extension Modal (global — scoped değil)
</style>

<style lang="scss">
.chrome-ext-modal {
    .ant-modal-body {
        padding: 0 !important;
    }

    .ant-modal-content {
        border-radius: 16px;
        overflow: hidden;
    }

    &__inner {
        display: flex;
        flex-direction: column;
    }

    // Carousel
    .ant-carousel {
        background: #000;
        border-radius: 16px 16px 0 0;
        overflow: hidden;
        height: 280px;

        .slick-slider,
        .slick-list,
        .slick-track,
        .slick-slide,
        .slick-slide > div {
            height: 100%;
        }
    }

    &__slide {
        height: 280px;
        display: flex !important;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
            width: 100%;
            height: 280px;
            object-fit: cover;
        }
    }

    .carousel-arrow {
        width: 36px;
        height: 36px;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 50%;
        display: flex !important;
        align-items: center;
        justify-content: center;
        z-index: 10;
        cursor: pointer;
        transition: background 0.2s;

        &:hover { background: #fff; }

        .material-icons { font-size: 22px; color: #333; }

        &--prev { left: 12px !important; }
        &--next { right: 12px !important; }
    }

    // Body
    &__body {
        padding: 28px 32px 32px;
    }

    &__header {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 16px;
    }

    &__icon {
        width: 56px;
        height: 56px;
        background: #e8faf0;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    &__title {
        font-size: 20px;
        font-weight: 700;
        color: #1a2332;
        line-height: 1.2;
    }

    &__subtitle {
        font-size: 13px;
        color: #25D366;
        font-weight: 600;
        margin-top: 2px;
    }

    &__lead {
        font-size: 14px;
        color: #4a5568;
        line-height: 1.7;
        margin-bottom: 20px;
    }

    &__features {
        list-style: none;
        padding: 0;
        margin: 0 0 24px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;

        li {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            background: #f8fafb;
            border-radius: 10px;
            padding: 12px 14px;

            .material-icons {
                color: #25D366;
                font-size: 20px;
                flex-shrink: 0;
                margin-top: 1px;
            }

            div {
                display: flex;
                flex-direction: column;
                gap: 2px;

                strong {
                    font-size: 13px;
                    font-weight: 600;
                    color: #2d3748;
                }

                span {
                    font-size: 12px;
                    color: #718096;
                    line-height: 1.5;
                }
            }
        }
    }

    &__setup {
        background: #f0fff4;
        border: 1px solid #c6f6d5;
        border-radius: 10px;
        padding: 16px 20px;
        margin-bottom: 24px;

        &-title {
            font-size: 13px;
            font-weight: 700;
            color: #276749;
            margin-bottom: 10px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        ol {
            padding-left: 18px;
            margin: 0;

            li {
                font-size: 13px;
                color: #2d6a4f;
                line-height: 1.7;
            }
        }
    }

    &__cta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: #25D366;
        color: #fff !important;
        font-size: 15px;
        font-weight: 700;
        border-radius: 12px;
        padding: 14px 24px;
        text-decoration: none !important;
        transition: background 0.2s, transform 0.15s;

        &:hover {
            background: #1ebe5d;
            transform: translateY(-2px);
        }
    }
}
</style>
